import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const getOrders = async ({ pageParam = null, status, limit = 10, startDate, endDate }) => {

  try {
    const response = await client.get("/orders", {
      params: {
        lastEvaluatedKey: pageParam,
        limit,
        status: status.join(','),
        startDate: startDate,
        endDate: endDate
      }
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};


export const getOrderById = async (orderId) => {
  try {
    const response = await client.get(`/orders/${orderId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const cancelOrder = async (orderId) => {
  try {
    const response = await client.delete(`/orders/${orderId}`);
    return response.data;
  } catch (err) {
    throw err
  }
}
